import { j as c } from "./atoms-v218.js";
import { forwardRef as f, useImperativeHandle as p } from "react";
import { CalendarContext as C } from "./atoms-v2772.js";
import { useDataManager as S } from "./atoms-v2773.js";
import { useDOMBuilder as x } from "./atoms-v2774.js";
import { useUserInteractions as D } from "./atoms-v2775.js";
import { DEFAULT_BATCH_SIZE as I } from "./atoms-v2776.js";
function v(t, e) {
  return () => ({
    actions: {
      resetDataManager() {
        t.reset();
      },
      resetUserInteractions(r) {
        e.reset(r);
      }
    }
  });
}
function M({
  children: t,
  config: e,
  dataSource: r,
  isLoading: i,
  onEmitNotification: s,
  onFetchNextData: d,
  onInternalError: m,
  onSelectionChange: l
}, u) {
  const o = x({ config: e }), a = S({
    batchSize: e.batchSize ?? I,
    dataSource: r,
    initialStartDate: e.initialStartDate,
    isLoading: i,
    onFetchNextData: d
  }), n = D({
    calendarYearConfigs: o.calendarYearConfigs,
    dataStore: a.dataStore,
    defaultSelection: e.defaultSelection,
    onEmitNotification: s,
    onInternalError: m,
    onSelectionChange: l
  });
  return p(u, v(a, n), []), /* @__PURE__ */ c.jsx(
    C.Provider,
    {
      value: {
        dataManager: a,
        domBuilder: o,
        userInteractions: n
      },
      children: t
    }
  );
}
const b = f(M);
export {
  b as CalendarContextProvider,
  M as UnforwardedComponent,
  v as getCalendarAPI
};
